import mutations from './covidRAT.mutations'
import actions from './covidRAT.actions'
import getters from './covidRAT.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
